import { apiClient } from "lib/apiClient";
import {
  IResearchIntakePreview,
  IResearchIntakeRequest,
} from "features/Research/types";

export const previewResearchIntake = async (
  request: IResearchIntakeRequest
): Promise<IResearchIntakePreview> => {
  const response = await apiClient.post("/research/intakes/preview", request);
  return response.data;
};
